// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609291312/js/" + chunkId + "." + {"44":"0721088b","225":"a7d83544","481":"83600003","486":"2ed63e44","770":"ee7158e9"}[chunkId] + ".0.7759180578688625.chunk.js";
};